import { DO_NOT_USE_platformMetrics } from '@sail/observability';
import { DEFAULT_LOCALE } from '../../internal/constants';
import createIntlWithLocale from '../../internal/createIntlWithLocale';
import { handleReactIntlError } from '../../internal/errors/handleReactIntlError/handleReactIntlError';
/**
 * @see https://sail.stripe.me/apis/intl/useIntl#format-message
 */ export default function formatMessage(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, reports, analytics, /** The message descriptor map object passed-in for formatting */ descriptor, /** The values allowed to be passed-in to the message */ ...values) {
    const locale = (descriptor === null || descriptor === void 0 ? void 0 : descriptor.translate) === false ? DEFAULT_LOCALE : config.locale;
    try {
        const defaultMessage = descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage;
        DO_NOT_USE_platformMetrics.trackTranslationCount('request');
        var _defaultMessage_length;
        DO_NOT_USE_platformMetrics.translationCountForMessageLength('request', (_defaultMessage_length = defaultMessage === null || defaultMessage === void 0 ? void 0 : defaultMessage.length) !== null && _defaultMessage_length !== void 0 ? _defaultMessage_length : 0);
        const intl = createIntlWithLocale(locale, config, reports, analytics);
        return intl.formatMessage({
            id: descriptor === null || descriptor === void 0 ? void 0 : descriptor.id,
            defaultMessage
        }, values[0]);
    } catch (error) {
        handleReactIntlError(reports, analytics, locale, error);
        var _descriptor_defaultMessage, _ref;
        return (_ref = (_descriptor_defaultMessage = descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage) !== null && _descriptor_defaultMessage !== void 0 ? _descriptor_defaultMessage : descriptor === null || descriptor === void 0 ? void 0 : descriptor.id) !== null && _ref !== void 0 ? _ref : '';
    }
}

//# sourceMappingURL=formatMessage.js.map